import ChatAxios from '@/chat.axios.config.js';

class ChatService {

    PREFIX = "v1/"

    listConversation(cancelToken) {
        return ChatAxios
            .get(this.PREFIX + 'chats/conversations', {cancelToken: cancelToken.token})
            .then(response => {
                return response.data.data;
            });
    }

    creatConversation(cancelToken, data) {
        return ChatAxios
            .post(this.PREFIX + 'chats/conversations',
                {
                    participants: data.participants,
                    name: data.name,
                    type: data.type
                },
                {
                    cancelToken: cancelToken.token
                }
            )
            .then(response => {
                return response.data.data;
            });
    }

    editConversation(cancelToken, conversationId, data) {
        return ChatAxios
            .patch(this.PREFIX + `chats/conversations/${conversationId}`,
                {
                    participants: data.participants,
                    name: data.name,
                },
                {
                    cancelToken: cancelToken.token
                }
            )
            .then(response => {
                return response.data;
            });
    }

    deleteConversation(cancelToken, conversationId) {
        return ChatAxios
            .delete(this.PREFIX + `chats/conversations/${conversationId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    leaveFromConversation(cancelToken, conversationId) {
        return ChatAxios
            .post(this.PREFIX + `chats/conversations/${conversationId}/!leave`, {}, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listMessage(cancelToken, conversationId, from, to) {
        const params = {};

        if (from)
            params['from'] = from

        if (to)
            params['to'] = to

        return ChatAxios
            .get(this.PREFIX + `chats/conversations/${conversationId}/messages`, {
                params: params,
                cancelToken: cancelToken.token
            })
            .then(response => {
                return response.data.data;
            });
    }

    newMessage(cancelToken, conversationId, data) {
        return ChatAxios
            .post(this.PREFIX + `chats/conversations/${conversationId}/messages`, {body: data.body}, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data.data;
            });
    }
}

export default new ChatService();